<script setup lang="ts">
interface Props {
    email: string;
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    disabled: false
})
</script>

<template>
    <v-tooltip
        location="top"
        content-class="bg-black border-sm text-tooltip"
        max-width="200"
    >
        <template #activator="{ props: bind }">
            <v-btn
                v-bind="bind"
                variant="text"
                size="20"
                color="base"
                icon="mdi-email-outline"
                rounded="lg"
                :disabled="props.disabled"
                :href="`mailto:${props.email}`"
                target="_blank"
            >
                <v-icon size="x-small">
                    mdi-email-outline
                </v-icon>
            </v-btn>
        </template>
        Send email
    </v-tooltip>
</template>

<style scoped>

</style>
